import { Label } from '@progress/kendo-react-labels'
import { StackLayout, GridLayoutItem } from '@progress/kendo-react-layout'
import { Input } from '@progress/kendo-react-inputs'
import { DropDownList } from '@progress/kendo-react-dropdowns'

const codeName = ['費目', '建物用途']

export default function CodeNameSearchCondition() {
  return (
    <>
      <h3>検索条件</h3>

      <StackLayout gap={5} orientation="vertical">
        <Label>コード区分</Label>
        <GridLayoutItem row={2} col={1} colSpan={1}>
          <DropDownList data={codeName} />
        </GridLayoutItem>

        <Label>コード</Label>
        <Input />

        <Label>名称</Label>
        <Input />

        <Label>略称</Label>
        <Input />

        <br></br>
        <h3>説明</h3>
        <p style={{ marginTop: '-5px' }}>建築する上での役割・担当</p>
      </StackLayout>
    </>
  )
}
